var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "review-sign"
  }, [_c('h2', [_vm._v("Review & Sign")]), _c('p', {
    staticClass: "review-sign-note"
  }, [_vm._v("Save your changes on each tab before signing.")]), _c('div', {
    staticClass: "review-attestation"
  }, [_c('p', [_vm._v("By electronically signing this attestation, you are confirming that:")]), _vm._m(0), _c('div', {
    staticClass: "review-sign-consent"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.isConfirmed,
      expression: "isConfirmed"
    }],
    attrs: {
      "type": "checkbox",
      "id": "review-confirm"
    },
    domProps: {
      "checked": Array.isArray(_vm.isConfirmed) ? _vm._i(_vm.isConfirmed, null) > -1 : _vm.isConfirmed
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.isConfirmed,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isConfirmed = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.isConfirmed = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.isConfirmed = $$c;
        }
      }
    }
  }), _c('label', {
    attrs: {
      "for": "review-confirm"
    }
  }, [_vm._v(" By signing below, you confirm that you have personally reviewed and approved the medical information submitted with your application. ")])])]), _c('div', {
    staticClass: "signature"
  }, [_vm._m(1), _c('signature-pad', {
    ref: "signpad",
    on: {
      "sign": _vm.onSign
    }
  })], 1), _c('div', {
    staticClass: "text-center mt-4"
  }, [_c('button', {
    staticClass: "submitSignature",
    attrs: {
      "type": "button",
      "disabled": !_vm.canSubmit
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm.isSubmitting ? _c('b-spinner', {
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" Submit ")], 1)])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ul', [_c('li', [_vm._v("You have reviewed the medical questions and answers submitted on your behalf.")]), _c('li', [_vm._v("The information is true, complete, and accurate to the best of your knowledge.")]), _c('li', [_vm._v("No known medical condition, diagnosis, treatment, medication, procedure, test, or other requested medical information has been intentionally omitted or misrepresented.")]), _c('li', [_vm._v("You understand that the underwriting decision will rely upon the information contained in your application.")]), _c('li', [_vm._v("If any answer is incorrect or incomplete, you will not sign the attestation until the information has been corrected.")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', [_c('b', [_vm._v("Signature (Required): ")]), _c('span', [_vm._v("(Sign your name using your mouse or touch screen in the box below)")])]);

}]

export { render, staticRenderFns }